// apps/client/src/App.tsx
import { useEffect } from "react";
import { AppRouter } from "@/router";
import { ToastProvider, ErrorBoundary } from "@yogo/ui";
import ServerErrorPage from "@/pages/error/ServerErrorPage";
import { useThemeStore } from "@/stores/themeStore";

function App() {
  const { theme } = useThemeStore();

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
  }, [theme]);

  return (
    <ErrorBoundary fallback={<ServerErrorPage />}>
      <ToastProvider position="top-right" defaultDuration={4000}>
        <AppRouter />
      </ToastProvider>
    </ErrorBoundary>
  );
}

export default App;

// Day 67 complete
